<template>
    <div class="row justify-content-center">
        <div class="col-lg-6 card-wrapper metadata">
            <card>
                <!-- Card header -->


                <div class="card-body">
                    <!-- Card body -->
                    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                        <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">
                            <!-- Input groups with icon -->
                            <b-row>

                                <b-col md="6">
                                    <base-input label="Firstname" prepend-icon="fas fa-user" placeholder="Firstname"  name="Firstname"
                                        rules="required" v-model="currentAccount.firstname"></base-input>
                                        
                                </b-col>
                                <b-col md="6">
                                    <base-input label="Lastname" prepend-icon="fas fa-user" placeholder="Lastname"  name="Lastname"
                                        rules="required" v-model="currentAccount.lastname"></base-input>
                                        
                                </b-col>


                                <b-col md="12" v-if="!passwords_match" style="color: red;"> 
                                    <p>Passwords do not match!</p>
                                </b-col>


                                <b-col md="6">
                                    <base-input label="Password" type="password" prepend-icon="fas fa-lock" placeholder="Password"  name="Password"
                                        rules="required" v-model="currentAccount.password"></base-input>
                                        
                                </b-col>
                                <b-col md="6">
                                    <base-input label="Password confirmation" type="password" prepend-icon="fas fa-lock" placeholder="Password confirmation"  name="Password confirmation"
                                        rules="required" v-model="currentAccount.password_confirmation"></base-input>
                                        
                                </b-col>

                                <!-- b-col md="6">
                                    <base-input name="Country of Origin" rules="required">
                                        <el-select v-model="currentAccount.country_name" filterable placeholder="Country"
                                            rules="required">
                                            <el-option v-for="option in countries" :key="option.label" :label="option.label"
                                                :value="option.value">
                                            </el-option>
                                        </el-select>
                                    </base-input>


                                    <base-input prepend-icon="fas fa-map-marker" placeholder="Password"  name="Password"
                                        rules="required" v-model="currentPhotoBook.password"></base-input>
                                        
                                </b-col -->
                                


                                <b-col md="12">
                                    
                                    <b-form-checkbox class="mb-3" v-model="accept_agreement" checked="">
                                        I hereby confirm the publishing agreement for my book <a target="_blank" :href="agreementUrl()">( download Publishing Agreement here )
                                        </a>
                                    </b-form-checkbox>
                                    <p v-if="accept_agreement">You will receive an email notification including a signed version of the publishing agreement.</p>
                                </b-col>

                            </b-row>

                        </form>
                    </validation-observer>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip, Select, Option } from 'element-ui'
import swal from '../../../../services/swal'


export default {
    name: 's01',
    components: {
        [Tooltip.name]: Tooltip,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            loading: false,
            countries: [],
            accept_agreement: false,
            passwords_match: false,
        }
    },
    methods: {
        agreementUrl(){
            return process.env.VUE_APP_API_HOST+"/agreement";
        },
        fetchCountries() {
            this.loading = true;
            this.$api.getCountries()
                .then((response) => {
                    const countries = response.data;
                    this.countries = countries.countries;
                    console.log(this.countries);
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        allDataValidated: function () {
                /*
                console.log(this.currentPhotoBook.title);
                console.log(this.currentPhotoBook.subtitle);
                console.log(this.currentPhotoBook.blurb);
                console.log(this.currentPhotoBook.bio);
                console.log(this.currentPhotoBook.orientation);
                console.log(this.currentPhotoBook.keywords);
                */
               console.log("Accept agreement ---> "+this.accept_agreement);
            if (
                this.currentAccount.firstname != "" &&
                this.currentAccount.lastname  != "" &&
                this.currentAccount.password  != "" &&
                this.currentAccount.password_confirmation  != "" &&
                this.accept_agreement
            ) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                return true;
            }
            this.$emit('denyProceed');
            return false;
        },
        passwordsMatch(){
            console.log("Passwords comparison!");
            if (this.currentAccount.password  == this.currentAccount.password_confirmation) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                //this.$emit('allowProceed');
                this.passwords_match = true;
                this.allDataValidated();
            }
            else{
                console.log("Passwords do not match!");
                this.passwords_match = false;
                this.$emit('denyProceed');
            }
            
            return false;  
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
        }),
        mayProceed: function () {
            return !this.allDataValidated();
        },
    },
    watch: {
        currentAccount: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
                this.passwordsMatch();
            },
            deep: true
        },
        accept_agreement: {
            handler:function (newItem) {
                this.allDataValidated();
            },
        },
    },
    mounted() {
        // this.$emit('denyProceed');
        // this.$emit('hideFooterNav');
        // this.allDataValidated();
        this.fetchCountries();
  
    }
};
</script>